export const commonPage = {
  previewPDFTitle: '查看PDF',
  constructionDrawingTitle: '施工图',
  loading: '加载中',
  nickname: '昵称',
  remark: '备注',
  enterRemark: '输入备注信息',
  phone: '手机',
  telephone: '电话'
}
